export default __webpack_public_path__ + "static/media/hero.3dd0a59e.jpg";